import React from 'react'
import { useIntl } from 'react-intl'
import { Column } from 'primereact/column'
import { DataTableFun } from '../../../utils/helpers/dataTableFun'
import useModal from '../../../utils/hooks/useModal'
import Modal from '../../../components/modal/Modal'
import GeneralForm from '../../../components/settings/GeneralForm'
import useAccess from '../../../utils/hooks/useAccess'
import { GROUPS, MODULES } from '../../../utils/constants/roles'
import useInputs from '../../../utils/hooks/useInputs'
import CenterSettingsService from '../../../services/settings/centers/centerSettings.service'
import useHandlerBasicActions from '../../../utils/hooks/useHandlerBasicActions'
import DataTableComp from '../../../components/common/data-table/DataTableComp'
import MainCommonView from '../../../components/common/MainCommonView'

const CenterGasTypes = () => {
  const { formatMessage: msg } = useIntl()

  const { isShowing, toggle } = useModal()
  const { canAdd, canDelete, canEdit } = useAccess()
  const { inputs, updateInputs, onChangeInputs } = useInputs()

  const dataFacade = useHandlerBasicActions({
    sortFieldInitial: 'name',
    getAll: CenterSettingsService.gasTypes.getAll,
    removeAction: CenterSettingsService.gasTypes.remove,
    editAction: CenterSettingsService.gasTypes.update,
    createAction: CenterSettingsService.gasTypes.create,
  })

  const handleCreate = async () => {
    const resp = await CenterSettingsService.gasTypes.create(inputs)
    if (resp) {
      closeModal()
      dataFacade.reload()
    }
  }

  const onRowEditComplete = async ({ newData }) => {
    const body = {
      name: newData.name,
      description: newData.description,
    }
    const { _id } = newData
    await dataFacade.edit({ _id, body })
  }

  const closeModal = () => {
    updateInputs({})
    toggle()
  }

  const headerOptions = {
    title: msg({ id: 'gasTypes' }),
    handlerHeaderActions: {
      showBackButton: true,
      secondaryButton: canAdd(MODULES.SETTINGS, GROUPS.CENTERS) && toggle,
      secondaryButtonText: 'button.add',
      secondaryButtonIcon: 'pi-plus',
    },
    searchOptions: dataFacade?.searchOptions,
  }

  const pagerOptions = {
    ...dataFacade?.pagerOptions,
    totalRecords: dataFacade?.data?.total,
  }

  const dataTable = (
    <DataTableComp
      loading={dataFacade?.loading}
      tableOptions={{
        className: 'table-without-menu',
        value: dataFacade?.data?.resp,
        dataKey: '_id',
        editMode: 'row',
        onRowEditComplete,
        ...dataFacade?.sortOptions,
      }}
      columns={[
        <Column
          style={{ width: '20%' }}
          field="name"
          editor={(rowData) => DataTableFun.textEditor(rowData)}
          header={msg({ id: 'name' })}
          sortable
        />,
        <Column
          style={{ width: '80%' }}
          field="description"
          sortable
          editor={(rowData) => DataTableFun.textEditor(rowData)}
          onCellEditComplete={DataTableFun.onCellEditComplete}
          header={msg({ id: 'description' })}
        />,

        canDelete && (
          <Column
            className="row-delete"
            align="right"
            body={(rowData) =>
              DataTableFun.buttonDelete(rowData, dataFacade.remove)
            }
          />
        ),
        canEdit && <Column className="row-edit" align="right" rowEditor />,
        // <Column className="row-view" body={(target) => goToPathButton(target)} />,
      ]}
    />
  )

  return (
    <div className="roles-container">
      <MainCommonView
        headerOptions={headerOptions}
        componentData={dataTable}
        pagerOptions={pagerOptions}
      />
      <Modal
        isShowing={isShowing}
        hide={closeModal}
        width="90%"
        maxWidth="450px"
        title={msg({ id: 'gasTypes.add.title' })}
        context={
          <GeneralForm
            inputs={inputs}
            handleSubmit={handleCreate}
            handleChange={onChangeInputs}
          />
        }
      />
    </div>
  )
}

export default CenterGasTypes
